export const SEARCH_POSTS = "[SEARCH] SEARCH POSTS";
export const SEARCH_SET_FILTER = "[SEARCH] SEARCH SET FILTER";
export const LOADING = "[SYSTEM] LOADING";
